import React from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import styled from 'styled-components';
import { X, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import Button from '../../components/ui/Button';
import CandidateProfileSections from './CandidateProfileSections';

// FE-35 + FE-28 (aday yarısı) — ADAY PROFİLİ.
//
// Bugüne kadar adaya dair tek yüzey liste satırıydı: CV'ye, ön yazıya, beklenen
// maaşa, kaynağın ayrıntısına (hangi ajans, kimin referansı) hiçbir ekrandan
// ulaşılamıyordu; onun yerine her satırda her zaman 0,00 olan "Sahtecilik Skoru"
// duruyordu.
//
// Neden GenericFormDrawer DEĞİL: bu bir FORM değil, salt okunur bir profil.
// Kabuk (react-modern-drawer + aynı başlık/gövde/ayak ölçüleri) GenericFormDrawer
// ve RequisitionDetailDrawer ile birebir aynı — tasarım dili ayrışmasın diye.

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #E8ECF0;
`;

const Title = styled.h3`
  font-size: ${({ theme }) => theme.metrics.font.size.lg};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  margin: 0;
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: none;
  color: ${({ theme }) => theme.colors.text.dark.little};
  cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.bgColor}; }
`;

// TEK KAYDIRMA: gövde kendi içinde kayar, sayfa kaymaz. `min-height: 0`
// atlanırsa flex çocuğu küçülmez ve taşma sayfaya döner (ev kuralı).
const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
`;

// Sol yaslı metin bağlantısı — ayak düğmeleri sağda kalır.
const FullProfileLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: auto;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.primary.main};
  &:hover { text-decoration: underline; }
`;

const Footer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #E8ECF0;
`;

// Profil bölümleri ve yardımcılar tek kaynaktan (CandidateProfileSections) gelir;
// eski dışa aktarımlar geriye uyum için yeniden ihraç edilir.
export { resumeFileName, candidateExpectedSalary } from './CandidateProfileSections';

// `onOpenFullProfile` verilirse ayakta "Tam Profili Aç" bağlantısı çizilir: çekmece
// hızlı bakıştır; notlar/etiketler/belgeler/rıza aday detay sayfasındadır.
export default function CandidateDetailDrawer({
  open, row, onClose, actions = [], onOpenFullProfile,
}) {
  const { t } = useTranslation();

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        direction="right"
        size="45%"
        duration={150}
        overlayOpacity={0.2}
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100vw',
          minWidth: 380,
          margin: '12px',
          borderRadius: '6px',
          height: 'calc(100vh - 24px)',
          boxShadow: '0 8px 32px rgba(0, 66, 66, 0.12)',
        }}
      >
        <Header>
          <Title>{t('ats.candidate.detailTitle')}</Title>
          <CloseBtn onClick={onClose} aria-label={t('common.close')}><X size={20} /></CloseBtn>
        </Header>

        <Body>
          {open && row && <CandidateProfileSections row={row} />}
        </Body>

        <Footer>
          {onOpenFullProfile && row?.id && (
            <FullProfileLink
              type="button"
              data-role="candidate-open-full-profile"
              onClick={() => onOpenFullProfile(row)}
            >
              <ExternalLink size={14} />
              {t('ats.candidate.openFullProfile')}
            </FullProfileLink>
          )}
          <Button variant="outline" onClick={onClose}>{t('common.close')}</Button>
          {actions.map((a) => (
            <Button key={a.action} variant={a.variant} onClick={a.onClick}>{a.label}</Button>
          ))}
        </Footer>
      </Drawer>
    </>
  );
}
